import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { fetchStoreInfo } from '../services/api';

const ProductCard = ({ product }) => {
  const { language, t } = useLanguage();
  const [storeInfo, setStoreInfo] = useState({});

  useEffect(() => {
    fetchStoreInfo().then(setStoreInfo).catch(() => {});
  }, []);

  const handleWhatsApp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!storeInfo.whatsapp) return;
    const message = encodeURIComponent(
      `Merhaba, ${product.name} hakkında bilgi almak istiyorum.`
    );
    window.open(`https://wa.me/${storeInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <Link 
      to={`/product/${product.id}`}
      className="group bg-[#fffef2] transition-all duration-500 hover:shadow-lg block"
    >
      {/* Image */}
      <div className="relative aspect-square overflow-hidden bg-[#f6f5e8]">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500 flex items-center justify-center">
          <button
            onClick={handleWhatsApp}
            className="opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500 px-6 py-3 bg-white text-[#333333] text-xs font-medium tracking-widest uppercase flex items-center gap-2"
          >
            <MessageCircle className="w-4 h-4" />
            {t('product.contact')}
          </button>
        </div>
      </div>

      {/* Details */}
      <div className="p-6">
        <h3 className="text-[#333333] text-lg font-light mb-2 group-hover:text-[#b8860b] transition-colors">
          {product.name}
        </h3>
        <p className="text-[#666666] text-sm mb-3">
          {product.description[language]}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-[#b8860b] text-sm font-medium">
            {product.karat} {t('product.karat')}
          </span>
          <span className="text-[#333333] text-xs font-medium tracking-wider uppercase group-hover:text-[#b8860b] transition-colors">
            {language === 'tr' ? 'Detaylar' : 'Details'}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
